import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCebisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4734_14342",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 100,
			height: 100,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 50,
				cy: 50,
				r: 50,
				fill: "#FF2180"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4734_14342)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: -21.7285,
				y: -1.04395,
				width: 138.462,
				height: 176.044,
				fill: "#FFD525"
			}), /* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip0_4734_14342)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M61.7924 70.0964C61.7924 72.0437 57.3513 73.5834 51.8679 73.5834C46.3845 73.5834 41.9434 71.9984 41.9434 70.0964C41.9434 68.1944 46.3845 66.6094 51.8679 66.6094C57.3513 66.6094 61.7924 68.1491 61.7924 70.0964Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M61.7924 74.3986C61.7924 76.3459 57.3513 77.8857 51.8679 77.8857C46.3845 77.8857 41.9434 76.3006 41.9434 74.3986C41.9434 72.4966 46.3845 70.9116 51.8679 70.9116C57.3513 70.8663 61.7924 72.4513 61.7924 74.3986Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M76.7934 119.005C76.9747 120.228 75.8871 121.451 74.301 121.632C59.3915 123.579 44.4821 123.579 29.5727 121.632C27.9866 121.405 26.899 120.228 27.0803 119.005C29.2555 105.057 29.2555 91.1091 27.0803 77.2062C26.899 75.9835 27.9866 74.7608 29.5727 74.5796C44.4821 72.6323 59.3915 72.6323 74.301 74.5796C75.8871 74.806 76.9747 75.9835 76.7934 77.2062C74.5729 91.1091 74.5729 105.057 76.7934 119.005Z",
						fill: "#F7A600"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M102.486 135.267L98.6792 134.271C102.395 120.096 99.7668 106.375 90.8393 93.5133C84.087 83.7768 76.1111 78.2066 76.0205 78.1613L78.2411 74.9007C78.6036 75.1271 86.8514 80.8784 94.0115 91.1584C103.528 104.88 106.474 120.142 102.486 135.267Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M85.0866 74.9912C86.0836 78.5235 83.999 82.1464 80.5095 83.1427C76.9748 84.139 73.3494 82.0559 72.3524 78.5688C71.3554 75.0365 73.3947 71.3683 76.9295 70.4173C80.4189 69.421 84.0896 71.4589 85.0866 74.9912Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M101.674 99.627C102.444 102.344 100.858 105.152 98.1392 105.922C95.4202 106.692 92.6105 105.107 91.8401 102.389C91.0697 99.6723 92.6558 96.8192 95.3749 96.0946C98.0939 95.3248 100.904 96.9098 101.674 99.627Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M0.342285 137.391L4.14894 136.395C0.43292 122.22 3.06133 108.499 11.9888 95.6375C18.7411 85.901 26.717 80.3308 26.8076 80.2855L24.5871 77.0249C24.2245 77.2513 15.9768 83.0027 8.81663 93.2826C-0.700014 106.959 -3.64564 122.22 0.342285 137.391Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M17.7446 77.0702C16.7477 80.6025 18.8323 84.2254 22.3217 85.2217C25.8565 86.218 29.4818 84.1348 30.4788 80.6478C31.4758 77.1155 29.4365 73.4473 25.9018 72.4963C22.4123 71.5 18.7416 73.5379 17.7446 77.0702Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M1.15653 101.706C0.38613 104.423 1.97224 107.231 4.69128 108.001C7.41032 108.77 10.22 107.185 10.9904 104.468C11.7608 101.751 10.1747 98.8981 7.45564 98.1735C4.7366 97.4036 1.92692 98.9886 1.15653 101.706Z",
						fill: "#1DBADF"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M60.1635 84.2705C56.81 84.2705 53.9097 86.1725 52.4596 88.935C51.0094 86.1725 48.1091 84.2705 44.7556 84.2705C39.952 84.2705 36.0547 88.1651 36.0547 92.9654C36.0547 104.332 52.4596 113.389 52.4596 113.389C52.4596 113.389 54.8614 112.076 57.8523 109.812C59.9823 108.182 62.3841 106.098 64.378 103.653C66.9611 100.574 68.9098 96.9053 68.9098 93.0107C68.8645 88.1651 64.9672 84.2705 60.1635 84.2705Z",
						fill: "#FF2180"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M49.7412 37.4901C50.6929 35.2258 51.7805 33.0974 52.8228 31.0142C55.0433 26.6667 57.0826 22.591 57.8077 17.6548L59.4391 17.8812C58.7141 23.0891 56.5841 27.3007 54.3183 31.7388C53.276 33.7766 52.1883 35.9051 51.282 38.1241L49.7412 37.4901Z",
						fill: "#4C291B"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M43.5758 34.7277C42.2163 32.6899 40.7208 30.7878 39.316 28.9311C36.2797 25.1271 33.4701 21.5042 31.8386 16.7944L30.2979 17.3379C32.0199 22.2741 34.9202 26.0328 38.0018 29.9727C39.4066 31.7841 40.8568 33.6409 42.2163 35.6335L43.5758 34.7277Z",
						fill: "#4C291B"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.5624 54.1103C18.9703 58.3672 20.6924 61.6731 22.4144 61.4919C24.1365 61.3108 25.1788 57.7784 24.7709 53.5216C24.3631 49.2647 22.641 45.9588 20.9189 46.1399C19.2422 46.2758 18.1546 49.8534 18.5624 54.1103Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M75.8427 48.5854C76.2506 52.8423 77.9726 56.1482 79.6947 55.967C81.4168 55.7859 82.459 52.2535 82.0512 47.9967C81.6433 43.7398 79.9213 40.4339 78.1992 40.615C76.5225 40.7962 75.4349 44.3738 75.8427 48.5854Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M78.3783 40.3888L75.342 40.6605C70.2211 34.6375 59.9794 31.0599 48.5594 32.1467C37.1394 33.2789 27.7588 38.7132 23.8615 45.642L20.8252 45.9137L22.366 61.6733L25.4023 61.4016C30.5231 67.4246 40.7648 71.0022 52.1848 69.9154C63.6048 68.8285 72.9855 63.3942 76.8375 56.4654L79.8737 56.1937L78.3783 40.3888Z",
						fill: "#F7A600"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M41.9403 53.1547C45.9999 53.1547 49.2908 49.866 49.2908 45.8093C49.2908 41.7525 45.9999 38.4639 41.9403 38.4639C37.8808 38.4639 34.5898 41.7525 34.5898 45.8093C34.5898 49.866 37.8808 53.1547 41.9403 53.1547Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.6602 48.7845C60.521 48.7845 62.84 46.4671 62.84 43.6083C62.84 40.7496 60.521 38.4321 57.6602 38.4321C54.7995 38.4321 52.4805 40.7496 52.4805 43.6083C52.4805 46.4671 54.7995 48.7845 57.6602 48.7845Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.5709 49.9985C45.1638 49.9985 47.2657 47.898 47.2657 45.3069C47.2657 42.7158 45.1638 40.6152 42.5709 40.6152C39.9779 40.6152 37.876 42.7158 37.876 45.3069C37.876 47.898 39.9779 49.9985 42.5709 49.9985Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.5049 46.9548C59.3845 46.9548 60.9082 45.4321 60.9082 43.5538C60.9082 41.6755 59.3845 40.1528 57.5049 40.1528C55.6253 40.1528 54.1016 41.6755 54.1016 43.5538C54.1016 45.4321 55.6253 46.9548 57.5049 46.9548Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M44.4347 49.6267C41.9876 50.623 39.2232 49.5361 38.2262 47.136C37.2292 44.7358 38.4075 41.9734 40.8093 40.9771C43.2111 39.9808 46.0208 41.0676 47.0178 43.4678C48.0148 45.868 46.8818 48.6304 44.4347 49.6267Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M54.2257 42.6982C53.8632 44.4644 55.0414 46.2306 56.8541 46.5928C58.6668 46.9551 60.4795 45.823 60.842 44.0568C61.2046 42.2907 60.0263 40.5245 58.2136 40.1622C56.4009 39.7999 54.5882 40.9321 54.2257 42.6982Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.675 48.0281C44.2818 48.0281 45.5844 46.7264 45.5844 45.1208C45.5844 43.5151 44.2818 42.2134 42.675 42.2134C41.0682 42.2134 39.7656 43.5151 39.7656 45.1208C39.7656 46.7264 41.0682 48.0281 42.675 48.0281Z",
						fill: "#1D1D1B"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.4919 45.4966C58.6633 45.4966 59.6128 44.5477 59.6128 43.3772C59.6128 42.2067 58.6633 41.2578 57.4919 41.2578C56.3206 41.2578 55.3711 42.2067 55.3711 43.3772C55.3711 44.5477 56.3206 45.4966 57.4919 45.4966Z",
						fill: "#1D1D1B"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.4891 47.1814C42.3984 47.7701 41.8546 48.1324 41.2655 48.0418C40.6764 47.9512 40.3138 47.4078 40.4045 46.8191C40.4951 46.2304 41.0389 45.8681 41.628 45.9586C42.1718 46.0945 42.5797 46.6379 42.4891 47.1814Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M57.8962 44.7813C58.0321 45.1888 58.4853 45.37 58.8479 45.2341C59.2557 45.0983 59.437 44.6454 59.301 44.2831C59.1651 43.8755 58.7119 43.6944 58.3494 43.8302C57.9415 43.9661 57.7602 44.3737 57.8962 44.7813Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M28.8498 24.0403C25.4963 23.2252 23.5023 19.8287 24.3181 16.5228C25.1338 13.1716 28.5326 11.1791 31.8407 11.9942C35.1942 12.8094 37.1882 16.2058 36.3725 19.5117C35.5568 22.8176 32.2033 24.8555 28.8498 24.0403Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M30.2508 15.6169C30.2508 14.6659 29.4804 13.896 28.5287 13.896C27.577 13.896 26.8066 14.6659 26.8066 15.6169C26.8066 16.5679 27.577 17.3377 28.5287 17.3377C29.4804 17.3377 30.2508 16.6132 30.2508 15.6169Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M60.4793 22.7269C63.0624 22.0928 64.6032 19.4663 63.9687 16.9302C63.3343 14.3489 60.7059 12.8092 58.1681 13.4432C55.585 14.0772 54.0442 16.7038 54.6786 19.2398C55.3131 21.8211 57.8962 23.3609 60.4793 22.7269Z",
						fill: "#83BB26"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M59.3896 16.2512C59.3896 15.5266 59.9788 14.8926 60.7492 14.8926C61.4742 14.8926 62.1087 15.4813 62.1087 16.2512C62.1087 17.021 61.5196 17.6097 60.7492 17.6097C59.9788 17.6097 59.3896 17.021 59.3896 16.2512Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M42.6221 56.7365C43.3018 60.45 48.0148 62.7596 53.181 61.8539C58.3472 60.9482 62.0179 57.1894 61.3835 53.4307",
						stroke: "#FF2180",
						strokeWidth: 2,
						strokeLinecap: "round"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4734_14342",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 110.769,
				height: 141.429,
				fill: "white",
				transform: "translate(-3.92578 11.813)"
			})
		}) })
	]
});
export default SvgIconCebisa;
